import { useNavigate } from 'react-router-dom';
import { useAppDispatch } from 'app/store';
import { fetchBillingInfo } from 'app/store/user';
import { Routes } from 'config/constants';
import { Card, CardContent, CardHeader } from 'components/ui/card';
import { Typography } from 'components/ui/typography';
import { DrawdownSetupForm } from 'pages/DrawdownBilling/components/DrawdownSetupForm';

const DRAWDOWN_SETUP_SKIPPED_KEY = 'drawdownSetupSkipped';

export default function DrawdownSetupPage() {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  async function handleSuccess() {
    // Await so PrivateRoute sees drawdownEnabled=true before navigating
    await dispatch(fetchBillingInfo());
    navigate(Routes.Billing);
  }

  function handleSkip() {
    sessionStorage.setItem(DRAWDOWN_SETUP_SKIPPED_KEY, 'true');
    navigate(Routes.Dashboard);
  }

  return (
    <div className="mx-auto mt-10 max-w-[560px]">
      <Card>
        <CardHeader className="border-b border-[var(--line)]">
          <Typography variant="h2" as="h1" className="mb-1">
            Fund Your Account
          </Typography>
          <Typography variant="small" as="p" className="text-[var(--text-muted)]">
            Drawdown billing pre-funds a balance that gets debited on each checkout. When your
            balance drops below the minimum threshold, we'll automatically top it up.
          </Typography>
        </CardHeader>
        <CardContent className="pt-6">
          <DrawdownSetupForm onSuccess={handleSuccess} onSkip={handleSkip} />
        </CardContent>
      </Card>
    </div>
  );
}

export { DRAWDOWN_SETUP_SKIPPED_KEY };
